import script from "./CalificarIndicadorUnificadoModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalificarIndicadorUnificadoModal.vue?vue&type=script&setup=true&lang=ts"

import "./CalificarIndicadorUnificadoModal.vue?vue&type=style&index=0&id=28f9a0df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28f9a0df"]])

export default __exports__